import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20background%20with%20soft%20cherry%20blossom%20petals%20floating%20in%20warm%20golden%20light%2C%20dreamy%20atmospheric%20gradient%20with%20pink%20and%20peach%20tones%2C%20cinematic%20wide%20composition%2C%20ethereal%20and%20elegant%20mood%2C%20subtle%20sparkle%20particles%2C%20clean%20minimal%20aesthetic&width=1800&height=900&seq=sakura-hero-bg&orientation=landscape"
        alt="樱花视频 - 高清影视在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="樱花视频 - 91视频与97视频免费全集"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
          樱花视频 - 高清在线观看
        </h1>
        <p className="text-base md:text-lg text-white/90 max-w-2xl mb-6 leading-relaxed">
          为您提供<strong>91视频</strong>、<strong>97视频</strong>等数字品牌视频的免费高清在线观看，涵盖91在线视频完整内容，不缓冲不卡顿，畅享海量影视资源。
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/category/hot-video"
            className="px-6 py-3 bg-primary-500 text-white rounded-md font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            热门推荐
          </Link>
          <Link
            to="/category/new-video"
            className="px-6 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-md font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/30 transition-colors"
          >
            最新上线
          </Link>
        </div>
      </div>
    </section>
  );
}